"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = require("styled-components");

const GlobalHeight = styled_components_1.createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  html,\n  body,\n  ", " {\n    height: 100%;\n  }"])), props => props.rootSelector);
exports.default = GlobalHeight;